// Test IDs for the Workouts feature (templates list, builder, exercise picker).

export const WORKOUTS = {
    root: 'workouts-root',
    newBtn: 'workouts-new-btn',
    list: 'workouts-list',
    empty: 'workouts-empty',
    item: 'workouts-item', // suffix with -{template_id}
    startBtn: 'workouts-start-btn', // -{template_id}
    duplicateBtn: 'workouts-duplicate-btn', // -{template_id}
    deleteBtn: 'workouts-delete-btn', // -{template_id}
    editLink: 'workouts-edit-link', // -{template_id}
};

export const WORKOUT_BUILDER = {
    root: 'workout-builder-root',
    nameInput: 'wb-name-input',
    notesInput: 'wb-notes-input',
    addExerciseBtn: 'wb-add-exercise-btn',
    saveBtn: 'wb-save-btn',
    cancelBtn: 'wb-cancel-btn',
    exerciseRow: 'wb-exercise-row', // -{index}
    targetSetsInput: 'wb-target-sets-input', // -{index}
    targetRepsInput: 'wb-target-reps-input', // -{index}
    entryNotesInput: 'wb-entry-notes-input', // -{index}
    removeExerciseBtn: 'wb-remove-exercise-btn', // -{index}
    dragHandle: 'wb-drag-handle', // -{index}
    emptyState: 'wb-empty-state',
};

export const EXERCISE_PICKER = {
    root: 'exercise-picker-root',
    searchInput: 'exercise-picker-search-input',
    categoryFilter: 'exercise-picker-category-filter',
    item: 'exercise-picker-item', // -{exercise_id}
    closeBtn: 'exercise-picker-close-btn',
    addSelectedBtn: 'exercise-picker-add-selected-btn',
    createCustomToggle: 'exercise-picker-create-custom-toggle',
    customNameInput: 'exercise-picker-custom-name-input',
    customCategorySelect: 'exercise-picker-custom-category-select',
    customEquipmentSelect: 'exercise-picker-custom-equipment-select',
    createCustomBtn: 'exercise-picker-create-custom-btn',
};
